import { getIdentity } from '@sdc/auth';
import { useEffect, useState, type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { Splash } from './Splash';

/**
 * Session-Guard des Hubs.
 *
 * Bewusst nicht `RequireAuth` aus `@sdc/auth`: das schickt ohne Session per
 * `window.location` auf den Hub-Login – im Hub selbst waere das ein Redirect auf
 * sich selbst (und auf Deploy-Previews auf die falsche Domain). Alle anderen Apps
 * nutzen weiter `RequireAuth`.
 */
export function RequireSession({ children }: { children: ReactNode }) {
  const [state, setState] = useState<'loading' | 'authed' | 'anon'>('loading');

  useEffect(() => {
    const identity = getIdentity();
    let active = true;

    identity.auth.getSession().then(({ data }) => {
      if (active) setState(data.session ? 'authed' : 'anon');
    });

    const { data: sub } = identity.auth.onAuthStateChange((_event, session) => {
      if (active) setState(session ? 'authed' : 'anon');
    });

    return () => {
      active = false;
      sub.subscription.unsubscribe();
    };
  }, []);

  if (state === 'loading') return <Splash label="Session wird geprüft …" />;
  if (state === 'anon') {
    const target = `${window.location.pathname}${window.location.search}`;
    return <Navigate to={`/login?next=${encodeURIComponent(target)}`} replace />;
  }
  return <>{children}</>;
}
